import { Formik } from "formik";
import { Button, MenuItem } from "@mui/material";
import CustomField from "../shared/CustomTextField";
import Styles from "./Form.module.css";
import { recoverUser } from "../../utils/API/userMethods";
import { useStore } from "../../hooks/store";
import { userRole } from "../../utils/config";
import PasswTextField from "../shared/PasswTextField";

export default function PasswordResetFrom() {
  const store = useStore();
  const userData = store.form.dataToUpdate;
  const initValues = {
    password: null,
    password_confirm: null,
  };

  const submitUser = (values) => {
    recoverUser(values, userData.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        if (values.password != values.password_confirm || !values.password) {
          setErrors({
            password: "Пароли должны совпадать",
            password_confirm: "Пароли должны совпадать",
          });
          return;
        }
        submitUser(values);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>Восстановление пароля</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <PasswTextField
                  error={errors.password}
                  type="password"
                  name="password"
                  label="Новый пароль"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                <PasswTextField
                  error={errors.password}
                  type="password"
                  name="password_confirm"
                  label="Подтвердите новый пароль"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password_confirm}
                />
                <span style={{ margin: "0 auto" }}>{errors.password}</span>
              </div>
            </div>

            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Отправить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
